import Vue from 'vue'
import Vuex from 'vuex'

import ImageSliders from './modules/ImageSliders';
import Blogs from './modules/Blogs';
import Facts from './modules/Facts';
import Events from './modules/Events';
import Persons from './modules/Person';
import Gallery from './modules/Gallery';
import Teams from './modules/Teams';
import Courses from './modules/Courses';
import Videos from './modules/Videos';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: { ImageSliders, Blogs, Facts, Events, Persons, Gallery, Teams, Courses, Videos }
})